import React, { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { setHeading } from "../../../accounts/account.actions";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { PDFHeader } from "../../../../../global/globalFunctions";
import { TruncatedText } from "../../../components/truncateText";
import jsPDF from "jspdf";
import MaterialTable from "material-table";


const ViewHSCode = (props) => {
    const tableRef = useRef();
    // function updateTableQuery() {
    //     tableRef.current.onQueryChange()
    // };

    useEffect(() => {
        props.setHeading("HS Code List")
    }, []);

    return (
        <>
            <Container fluid>
                <MaterialTable
                    tableRef={tableRef}
                    style={{ zIndex: 0 }}
                    title="HS Code List"
                    columns={[
                        {
                            title: "SR No.",
                            field: "sequenceNumber",
                            editable: "never",
                        },
                        {
                            title: "PCT Code",
                            field: "pctCode",
                            editable: "never",
                        },
                        {
                            title: "Description",
                            field: "description",
                            editable: "never",
                            cellStyle: {
                                whiteSpace: 'normal',
                                wordBreak: "break-word",
                                lineHeight: "20px"
                            }
                        }
                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/HSCode/get-codes?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + (query.page);
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: "GET",
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    options={{
                        actionsColumnIndex: -1,
                        exportButton: true,
                        exportAllData: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200],
                        headerStyle: {
                            position: "sticky",
                            top: 0,
                            color: "#00BBBB",
                            fontWeight: "550",
                            onRowAdd: "none",
                            whiteSpace: 'nowrap',
                        },
                        exportPdf: (columns, data) => {
                            const unit = "pt";
                            const size = "A4";
                            const orientation = "potrait";
                            const doc = new jsPDF(orientation, unit, size);
                            PDFHeader(doc, "HS Code Details");

                            const columnTitles = columns.map(columnDef => columnDef.title);
                            const pdfData = data.map((elt) => [
                                elt.sequenceNumber,
                                elt.pctCode,
                                elt.description,
                            ]);
                            let content = {
                                startY: 120,
                                startX: 5,
                                head: [columnTitles],
                                body: pdfData,
                                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                                styles: { fontSize: 9 },
                                theme: "grid",
                            };

                            doc.setFontSize(11)
                            doc.setFont("Times New Roman", "Normal")
                            doc.autoTable(content);

                            doc.setProperties({ title: 'HS Code Details' })
                            doc.output('dataurlnewwindow')
                        },
                    }}
                    editable={{
                        // isDeleteHidden: true,
                        // isEditHidden: true,
                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    // props.UpdateUser(newData, oldData);
                                }, 600);
                            }),
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    // props.deleteUser(oldData._id, updateTableQuery);
                                }, 600);
                            }),
                    }}
                    actions={[
                        {
                            icon: 'refresh',
                            tooltip: 'Refresh Data',
                            isFreeAction: true,
                            onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                        },
                    ]}
                />
            </Container>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        // deleteUser: (id) => dispatch(deleteUserRes(id)),
        // UpdateUser: (newData, oldData) => dispatch(UpdateUserRes(newData, oldData)),
        setHeading: (data) => dispatch(setHeading(data))
    };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewHSCode);